import * as React from 'react'
import PropTypes from 'prop-types'
import { Link, graphql } from 'gatsby'

const CtaLink = ({ title, url, download, openInNewTab }) => {
  url = (url || '').replace('https://www.grayandsons.com/', '/')
  const isInternal = (url || '').startsWith('/')
  const props = {}
  if (download) {
    props.download = 'download'
  }
  return (
    <div className="mx-auto">
      {isInternal ? (
        <Link
          to={url}
          className="block mx-auto max-w-max rounded-md border-2 border-red-700 bg-red-700 text-center font-bold text-white duration-200 hover:-translate-y-1 hover:border-red-700 hover:bg-white hover:text-red-700 hover:shadow-lg my-2 px-3 py-2 text-sm md:text-base "
        >
          {title}
        </Link>
      ) : (
        <a
          href={url}
          className="block mx-auto no-underline max-w-max rounded-md border-2 border-red-700 bg-red-700 text-center font-bold text-white duration-200 hover:-translate-y-1 hover:border-red-700 hover:bg-white hover:text-red-700 hover:shadow-lg my-2 px-3 py-2 text-sm md:text-base "
          target={openInNewTab ? '_blank' : '_self'}
          rel="noreferrer"
          {...props}
        >
          {title}
        </a>
      )}
    </div>
  )
}

export const CtaLinkSection = ({ section }) => {
  return (
    <section className="my-10">
      <CtaLink {...section} />
    </section>
  )
}
CtaLink.propTypes = {
  title: PropTypes.string,
  url: PropTypes.string,
  download: PropTypes.bool,
  openInNewTab: PropTypes.bool,
}

export const query = graphql`
  fragment CtaLink on STRAPI__COMPONENT_SHARED_LINK {
    id
    url
    title
    strapi_component
    openInNewTab
    download
  }
`

export default CtaLink
